var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"titulo"},[_c('h2',[_vm._v(_vm._s(_vm.Titulo)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }